exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select.category {\n  padding: 24px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/advanced/select-category/select-category.component.css
// module id = 1378
// module chunks = 2